export default function NueraLogo({ className = "h-8 w-auto" }) {
  return (
    <img
      src="/nuera-logo.png"
      alt="Nuera"
      className={className}
      data-testid="nuera-logo"
      draggable={false}
    />
  );
}
